import { validatePresenceOf, formatLegalActDate } from '@/shared/utils';

export const validate = marriage => {
  return validatePresenceOf(marriage, ['date', 'city', 'type']);
};

export const buildContent = marriage => {
  const line = `Mariés le  ${formatLegalActDate(marriage.date)} par devant l'officier de l'Etat civil de ${marriage.city} sous le régime de la ${marriage.type}.`;
  return [line];
};